module.exports = __webpack_public_path__ + "img/cmfg1.182fe615.jpg";